import { useEffect, useState } from 'react';

import { findAddressById } from '@bodilenergy/address';

import { AddressWithBbrId } from '~src/model';
import { toAddressFromDAWAAddress } from '~src/util';
import { useLocation } from '~src/hooks/useLocation';

export const useAddressLookupByID = (): AddressWithBbrId | undefined => {
  const [address, setAddress] = useState<AddressWithBbrId>();

  const { location } = useLocation();
  const parameters = new URLSearchParams(location?.search);
  const addressID = parameters?.get('addressID') ?? undefined;

  useEffect(() => {
    if (!addressID) {
      return;
    }

    const controller = new AbortController();

    findAddressById(addressID, { signal: controller.signal })
      .then(data => {
        if (!data || controller.signal.aborted) {
          return;
        }

        setAddress(toAddressFromDAWAAddress(data));
      })
      // Unknown IDs resolve to undefined; on provider failures the customer enters the address instead.
      .catch(() => undefined);

    return () => controller.abort();
  }, [addressID]);

  return address;
};
